import { createPaths } from "@routes/utils";

import type { IExtractRouteParamMap } from "@routes";

const baseRoute = `/warehouse-management/sales-warehouse-inventory`;

export const salesWarehouseInventoryRoutesObj = {
  list: baseRoute,
  create: `${baseRoute}/create/:warehouseId`,
  edit: `${baseRoute}/edit/:productId`,
  warehouseExit: `${baseRoute}/warehouse-exit/:productId/:warehouseId`,
  sendToScrapWarehouse: `${baseRoute}/send-to-scrap-warehouse/:productId/:warehouseId`,
  returnFromScrapWarehouse: `${baseRoute}/return-from-scrap-warehouse/:productId/:warehouseId`,
  transferToSalesWarehouse: `${baseRoute}/transfer-to-sales-warehouse/:productId/:warehouseId`,
} as const;

export type ISalesWarehouseInventoryRouteParams = IExtractRouteParamMap<
  typeof salesWarehouseInventoryRoutesObj
>;

export const salesWarehouseInventoryPath = createPaths<
  typeof salesWarehouseInventoryRoutesObj,
  ISalesWarehouseInventoryRouteParams
>(salesWarehouseInventoryRoutesObj);
